const initialState = {
    error: false,
    ratio: 0.5,
    size: 2000,
    adjust: 300,
    mapData: {
        team: [],
        infos: {},
        time: {},
        map: {}
    },
    heatmap: {
        target: 0,
        deaths: [],
        positions: [],
        startTime: 0,
        endTime: 0,
    }
};

const exampleMapData = {
    infos: {
        headerImage: "https://i.imgur.com/eDuqSUf.png",
        map: "proceduralmap_4250_793953348_217_1633562907",
        mapSize: 4250,
        maxPlayers: 250,
        name: "Rustoria.co - EU Main",
        players: 106,
        queuedPlayers: 0,
        salt: 1,
        seed: 93928,
        updatedAt: 1634757869,
        url: "http://rustoria.co",
        wipeTime: 1634220108
    },
    map: {
        background: "#12404D",
        height: 3250,
        monuments: [
            {_id: '61703d3400f8ba050297bb36', token: 'harbor_display_name', x: 3931.90576171875, y: 3856.092041015625},
            {_id: '61703d3400f8ba050297bb37', token: 'train_tunnel_display_name', x: 3954, y: 3759},
            {_id: '61703d3400f8ba050297bb38', token: 'harbor_2_display_name', x: 2464.922607421875, y: 4163.99169921875},
            {_id: '61703d3400f8ba050297bb39', token: 'train_tunnel_display_name', x: 2544, y: 4197},
            {_id: '61703d3400f8ba050297bb3a', token: 'fishing_village_display_name', x: 1365.540771484375, y: 4077.212890625},
            {_id: '61703d3400f8ba050297bb3b', token: 'fishing_village_display_name', x: 3502.82861328125, y: 4061.1279296875},
            {_id: '61703d3400f8ba050297bb3c', token: 'oil_rig_small', x: 4070.166015625, y: 4766.9580078125},
            {_id: '61703d3400f8ba050297bb3d', token: 'large_oil_rig', x: 699.1488037109375, y: 4747.9794921875},
            {_id: '61703d3400f8ba050297bb3e', token: 'airfield_display_name', x: 2484.639892578125, y: 3599.489990234375},
            {_id: '61703d3400f8ba050297bb3f', token: 'train_tunnel_display_name', x: 2328, y: 3507},
            {_id: '61703d3400f8ba050297bb40', token: 'sewer_display_name', x: 3428.6953125, y: 3331.612060546875},
            {_id: '61703d3400f8ba050297bb41', token: 'water_treatment_plant_display_name', x: 2850.658203125, y: 2815.125},
            {_id: '61703d3400f8ba050297bb42', token: 'train_tunnel_display_name', x: 2721, y: 2766},
            {_id: '61703d3400f8ba050297bb43', token: 'power_plant_display_name', x: 1861.2099609375, y: 3007.3701171875},
            {_id: '61703d3400f8ba050297bb44', token: 'train_tunnel_display_name', x: 1821, y: 2931},
            {_id: '61703d3400f8ba050297bb45', token: 'outpost', x: 2093.538330078125, y: 2420.855224609375},
            {_id: '61703d3400f8ba050297bb46', token: 'train_tunnel_display_name', x: 2136, y: 2514},
            {_id: '61703d3400f8ba050297bb47', token: 'train_yard_display_name', x: 2602.550048828125, y: 2054.659912109375},
            {_id: '61703d3400f8ba050297bb48', token: 'train_tunnel_display_name', x: 2532, y: 2061},
            {_id: '61703d3400f8ba050297bb49', token: 'military_tunnels_display_name', x: 1700.383056640625, y: 1372.5965576171875},
            {_id: '61703d3400f8ba050297bb4a', token: 'train_tunnel_display_name', x: 1662, y: 1455},
            {_id: '61703d3400f8ba050297bb4b', token: 'launchsite', x: 1762.727783203125, y: 742.476806640625},
            {_id: '61703d3400f8ba050297bb4c', token: 'train_tunnel_display_name', x: 1677, y: 558},
            {_id: '61703d3400f8ba050297bb4d', token: 'dome_monument_name', x: 2340.368408203125, y: 1311.562744140625},
            {_id: '61703d3400f8ba050297bb4e', token: 'large_fishing_village_display_name', x: 1931.35400390625, y: 239.4630126953125},
            {_id: '61703d3400f8ba050297bb4f', token: 'stables_b', x: 2969.1416015625, y: 3404.28955078125},
            {_id: '61703d3400f8ba050297bb50', token: 'stables_a', x: 1955.335205078125, y: 1781.516357421875},
            {_id: '61703d3400f8ba050297bb51', token: 'supermarket', x: 2117.92626953125, y: 3330.251220703125},
            {_id: '61703d3400f8ba050297bb52', token: 'mining_outpost_display_name', x: 2683.684814453125, y: 3088.93212890625},
            {_id: '61703d3400f8ba050297bb53', token: 'mining_outpost_display_name', x: 2779.8291015625, y: 1128.2520751953125},
            {_id: '61703d3400f8ba050297bb54', token: 'gas_station', x: 1107.6956787109375, y: 1396.45068359375},
            {_id: '61703d3400f8ba050297bb55', token: 'gas_station', x: 3323.54296875, y: 1644.11083984375},
            {_id: '61703d3400f8ba050297bb56', token: 'mining_outpost_display_name', x: 3312.25341796875, y: 2989.3984375},
            {_id: '61703d3400f8ba050297bb57', token: 'supermarket', x: 1123.2911376953125, y: 2449.69189453125},
            {_id: '61703d3400f8ba050297bb58', token: 'supermarket', x: 1408.112548828125, y: 624.334716796875},
            {_id: '61703d3400f8ba050297bb59', token: 'gas_station', x: 1065.189453125, y: 3271.48046875},
            {_id: '61703d3400f8ba050297bb5a', token: 'underwater_lab', x: 260.80712890625, y: 40.07958984375},
            {_id: '61703d3400f8ba050297bb5b', token: 'DungeonBase', x: 260.80712890625, y: 40.07958984375},
            {_id: '61703d3400f8ba050297bb5c', token: 'underwater_lab', x: 4057.520263671875, y: 4244.36767578125},
            {_id: '61703d3400f8ba050297bb5d', token: 'DungeonBase', x: 4057.520263671875, y: 4244.36767578125},
            {_id: '61703d3400f8ba050297bb5e', token: 'underwater_lab', x: 305.361328125, y: 1323.7265625},
            {_id: '61703d3400f8ba050297bb5f', token: 'DungeonBase', x: 305.361328125, y: 1323.7265625},
            {_id: '61703d3400f8ba050297bb60', token: 'underwater_lab', x: 3912.266845703125, y: 228.4571533203125},
            {_id: '61703d3400f8ba050297bb61', token: 'DungeonBase', x: 3912.266845703125, y: 228.4571533203125},
            {_id: '61703d3400f8ba050297bb62', token: 'underwater_lab', x: 580.64404296875, y: 4243.1396484375},
            {_id: '61703d3400f8ba050297bb63', token: 'DungeonBase', x: 580.64404296875, y: 4243.1396484375},
            {_id: '61703d3400f8ba050297bb64', token: 'underwater_lab', x: 2546.73876953125, y: 4390.193359375},
            {_id: '61703d3400f8ba050297bb65', token: 'DungeonBase', x: 2546.73876953125, y: 4390.193359375}
        ],
        oceanMargin: 500,
        updatedAt: 1634745652,
        width: 3250,
        wipeAt: 1634572800
    },
    team: [
        {
            avatar: "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/8d/8dbfa9d6d254a9b7292021a4cc7df99d8dc20ca0_full.jpg",
            deathTime: 0,
            isAlive: true,
            isOnline: true,
            name: "Crash | rustLink.io",
            spawnTime: 1634805890,
            steamId: "76561198797572112",
            x: 2059.2861328125,
            y: 3816.2587890625
        }
    ]

};

const exampleSize = 2725;
const exampleRatio = 0.5;

export const map = (state = initialState, action) => {
    switch (action.type) {
        case "RESET_MAP": {
            return initialState;
        }
        case "SET_DEFAULT_MAP":
            return {
                ...state,
                error: action.error,
                mapData: exampleMapData,
                size: exampleSize,
                ratio: exampleRatio
            }
        case "UPDATE_MAP":
            return {
                ...state,
                mapData: {
                    team: action.data.team || state.mapData.team,
                    infos: action.data.infos || state.mapData.infos,
                    time: action.data.time || state.mapData.time,
                    map: action.data.map || state.mapData.map
                },
                vendings: action.data.vendings,
                size: (action.data.map || state.mapData.map).width - 2 * (action.data.map || state.mapData.map).oceanMargin + state.adjust * 2,
                ratio: ((action.data.map || state.mapData.map).width - 2 * (action.data.map || state.mapData.map).oceanMargin) / (action.data.infos || state.mapData.infos).mapSize,
                error: false
            }
        case "UPDATE_TEAM":
            return {
                ...state,
                mapData: {
                    team: action.team || state.mapData.team,
                    infos: state.mapData.infos,
                    time: state.mapData.time,
                    map: state.mapData.map
                }
            }
        case "UPDATE_MARKERS":
            var current = { ...state };
            if (action.vendings)
            {
                if (action.vendings.add && action.vendings.add.length)
                    current.vendings = current.vendings?.concat(action.vendings.add);
                if (action.vendings.remove && action.vendings.remove.length)
                    current.vendings = current.vendings?.filter(e => !action.vendings.remove.contains(e.id));
                if (action.vendings.update && action.vendings.update.length)
                {
                    for (const update of action.vendings.update)
                    {
                        var vending = current.vendings?.find(e => e.id === update.id);
                        if (vending) 
                            vending = update;
                    }
                }
            }
            return {
                ...state,
                markers: action.markers,
                vendings: current.vendings
            }
        case "UPDATE_HEATMAP":
            return {
                ...state,
                heatmap: {
                    target: action.data.target,
                    deaths: action.data.deaths,
                    positions: action.data.positions,
                    startTime: action.data.startTime,
                    endTime: action.data.endTime
                }
            }
        default:
            return state;
    }
};
